import type { MaybeRefOrGetter } from '@vueuse/shared'
import type { Ref } from 'vue'

import { getPlatformId } from '~/features-shared/config-manager/stores/swym-config'

const PREFIX = window.widget ? '3DSWYM' : '3DSWYMV3'
const SEPARATOR = '-'
let USER_ID = ''

interface LSMOptions {
  separator?: string
  prefix?: string
}

export function setupUserIdForLocalStorageManager(userId: string) {
  USER_ID = userId
}

/**
 * Get the prefixed key
 * @param key localstorage key
 * @param options.tenant Set true to use the tenant in the key
 * @param options.separator Set a custom separator, default "-"
 * @param options.prefix Set a custom prefix, default "3DSWYMV3"
 * @param options.widget Set the widget to use the widget id in the key
 * @returns prefixed key
 */
export function buildPrefixedKey(key: string, options?: LSMOptions): string {
  const separator = options?.separator || SEPARATOR
  const prefix = options?.prefix ? PREFIX + separator + options.prefix : PREFIX
  const fullKey = [prefix, getPlatformId(), USER_ID]

  if (window.widget?.id)
    fullKey.push(window.widget.id)

  fullKey.push(key)

  return fullKey.join(separator)
}

export function useLocalStorageManager<T>(key: string, value: MaybeRefOrGetter<T>, options?: LSMOptions): Ref<T> {
  const prefix = buildPrefixedKey(key, options)
  return useLocalStorage<T>(prefix, value, {
    serializer: {
      read: (v: any) => (v && v !== 'undefined') ? JSON.parse(v) : null,
      write: (v: any) => JSON.stringify(v),
    },
  }) as Ref<T>
}
